import React from "react";
import PropTypes from "prop-types";
import QualificadaDesktop from "./QualificadaDesktop";

function Qualificada({ app, config }) {
  return <QualificadaDesktop app={app} config={config} />;
}

Qualificada.defaultProps = {
  app: null,
  config: {},
};

Qualificada.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default Qualificada;
